import React from "react";

const SvgPeople = props => (
  <svg data-name="Layer 1" viewBox="0 0 215 215" {...props}>
    <path
      d="M81.75 108.9a41.22 41.22 0 01-16.69-3.5l-2.1-.93v68.47h37.59v-68.49l-2.11.94a40.89 40.89 0 01-16.69 3.51zm15.8 61H66V109a44.54 44.54 0 0031.59 0zM81.76 42.06a27.81 27.81 0 1027.8 27.81 27.85 27.85 0 00-27.8-27.81zm0 52.61a24.81 24.81 0 1124.8-24.8 24.84 24.84 0 01-24.8 24.8zm55.99 24.69a33.88 33.88 0 01-13.75-2.88l-2.1-.93v57.39h31.66v-57.4l-2.11.93a33.57 33.57 0 01-13.7 2.89zm12.83 50.58h-25.66v-49.86a37.16 37.16 0 0025.66 0zM137.75 64a23.3 23.3 0 1023.3 23.3 23.32 23.32 0 00-23.3-23.3zm0 43.6a20.3 20.3 0 1120.3-20.3 20.33 20.33 0 01-20.3 20.27z"
      fill="currentColor"
    />
  </svg>
);

export default SvgPeople;